import { resolveUrl } from "~/utils/url/urlResolver";

export interface QuoteNotificationUrlData {
  quoteNumber: string;
  account?: string;
  salesOrg?: string;
}

export function getQuoteDetailsUrl(data: QuoteNotificationUrlData) {
  const baseUrl = resolveUrl(`/quotes/${data.quoteNumber}`);
  const urlParams = new URLSearchParams();

  if (data.account) {
    urlParams.append("account", data.account);
  }
  if (data.salesOrg) {
    urlParams.append("salesOrg", data.salesOrg);
  }
  const query = urlParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}
